import { get } from '../../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../../config'

// 获取首页看板
export const GET_DASHBOARD_DATA = () => {
  return get(`${OPERATION_CENTER_PREFIX}/statistics/v1/main`)
}
